import { Injectable, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';
import { filter, map } from 'rxjs';
import { PwaInstallService } from '@core/services/pwa-install.service';
import { PwaUpdateService } from '@core/services/pwa-update.service';

const SUPPRESSED_ROUTES = ['/auth', '/basket'];

@Injectable({ providedIn: 'root' })
export class PwaUiService {
  private readonly _install = inject(PwaInstallService);
  private readonly _update = inject(PwaUpdateService);
  private readonly _router = inject(Router);

  private readonly _url = toSignal(
    this._router.events.pipe(
      filter((e): e is NavigationEnd => e instanceof NavigationEnd),
      map((e) => e.urlAfterRedirects),
    ),
    { initialValue: this._router.url },
  );

  private readonly _suppressed = computed(() => {
    const url = this._url();
    return SUPPRESSED_ROUTES.some(
      (route) => url === route || url.startsWith(`${route}/`),
    );
  });

  readonly showUpdate = this._update.updateAvailable;

  readonly showInstall = computed(
    () => this._install.canShow() && !this._suppressed() && !this.showUpdate(),
  );
}
